<script setup lang="ts">
import { useCoursesStore } from '~~/stores/courses'

const props = withDefaults(
  defineProps<{
    show?: boolean
  }>(),
  {
    show: false
  }
)

const emits = defineEmits(['cancel'])

const router = useRouter()
const route = useRoute()
const { addCdnToUrl } = useFormatUrlCdn()

const courseStore: Record<string, any> = useCoursesStore()
const courseDetail = computed(() => courseStore.state.courseDetail)

const startLearning = () => {
  const section = courseDetail.value?.data?.sections[0]
  router.replace({
    path: `${route.path}/materi`,
    query: {
      courseSerial: courseDetail.value?.data?.serial,
      sectionSerial: section?.serial,
      contentSerial: section?.contents[0]?.serial
    }
  })
}

const moveToStudySaya = () => {
  router.push('/user/studi-saya')
}
</script>

<template>
  <ClientOnly>
    <AtomsModal
      :visible="show"
      width="100%"
      centered
      :closable="false"
      wrap-class-name="kursus-detail__payment-sucess full-modal"
      :mask="false"
      @cancel="emits('cancel')"
    >
      <div class="payment-sucess__content">
        <div class="content-icon"><LazyAtomsIconCurlySuccess /></div>
        <div class="content-title">Kursus berhasil di beli!</div>

        <div class="content-kursus">
          <div class="content-kursus__image">
            <nuxt-img
              class="mx-auto"
              :src="addCdnToUrl(courseDetail?.data?.thumbnailURL)"
              :alt="courseDetail?.data?.urlSlug"
              loading="lazy"
              sizes="10vw"
              format="webp"
              quality="60"
              height="86"
              preload
            />
          </div>
          <div class="content-kursus__title">
            {{ courseDetail?.data?.title ?? '-' }}
          </div>
        </div>

        <div class="mb-4">
          <a-button
            class="w-3/4 md:w-[290px]"
            type="primary"
            size="large"
            @click="startLearning"
          >
            Mulai Belajar
          </a-button>
        </div>

        <div>
          <a-button
            class="w-3/4 md:w-[290px]"
            size="large"
            @click="moveToStudySaya"
          >
            Lihat Kursus Saya
          </a-button>
        </div>
      </div>
    </AtomsModal>
  </ClientOnly>
</template>

<style lang="scss">
@use './styles.scss';
</style>
